export enum StripePriceFields {
  stripePriceId = "stripePriceId",
  nickname = "nickname",
  amount = "amount",
  interval = "interval",
  token = "token",
  status = "status",
  actions = "actions",
}
